import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";

@Component({
  selector: 'app-vehicle-information',
  templateUrl: './vehicle-information.component.html',
  styleUrls: ['./vehicle-information.component.css']
})
export class VehicleInformationComponent implements OnInit, OnChanges {

  @Input() public claim: ClaimDto | null = null;

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }

}
